import * as e from "react";
const o = (t) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...t }, /* @__PURE__ */ e.createElement("path", { d: "M8 7l4-4 4 4h-3v8h-2V7H8zM3 19c0 1.1.9 2 2 2h14a2 2 0 002-2v-5h-2v5H5v-5H3v5z", clipRule: "evenodd" }));
export {
  o as ReactComponent
};
